export class CalendarData
{
	private readonly _dateL: Date;
	private readonly _dateR: Date;

	public get yearL(): number
	{
		return this._dateL.getFullYear();
	}

	public get yearR(): number
	{
		return this._dateR.getFullYear();
	}

	public get monthL(): number
	{
		return this._dateL.getMonth();
	}

	public get monthR(): number
	{
		return this._dateR.getMonth();
	}

	constructor()
	{
		this._dateL = new Date();
		this._dateR = new Date(this._dateL.getFullYear(), this._dateL.getMonth() + 1);
	}

	public onNextMonth(): void
	{
		this._dateL.setMonth(this._dateL.getMonth() + 1);
		this._dateR.setMonth(this._dateR.getMonth() + 1);
	}

	public onPrevMonth(): void
	{
		this._dateL.setMonth(this._dateL.getMonth() - 1);
		this._dateR.setMonth(this._dateR.getMonth() - 1);
	}

	public isPrevNavEnabled(): boolean
	{
		const now = new Date();

		return !(now.getFullYear() === this._dateL.getFullYear() && now.getMonth() === this._dateL.getMonth());
	}
}
